import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltActivityLogHeaderFilterTriggerWireframe from './VeltActivityLogHeaderFilterTriggerWireframe/VeltActivityLogHeaderFilterTriggerWireframe';
import VeltActivityLogHeaderFilterContentWireframe from './VeltActivityLogHeaderFilterContentWireframe/VeltActivityLogHeaderFilterContentWireframe';
var VeltActivityLogHeaderFilterWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-filter-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogHeaderFilterWireframe.Trigger = VeltActivityLogHeaderFilterTriggerWireframe;
VeltActivityLogHeaderFilterWireframe.Content = VeltActivityLogHeaderFilterContentWireframe;
export default VeltActivityLogHeaderFilterWireframe;
